const defaultMessagesState = [];

const messagesReducer = (state = defaultMessagesState, action) => {
  let newState = state.slice(); // create copy to avoid mutating original, which stops connect() from detecting changes
  switch (action.type) {
    case 'ADD_MESSAGE':
      if (action.item.message === '' || action.item.message === null) {
        return state;
      }
      newState.splice(action.index, 0, action.item); // index is the position to add at
      return newState;
    case 'SET_MESSAGE_RENDERED':
      // Find the matching id to change
      for (let i = 0, len = newState.length; i < len; i++) {
        if (action.id === newState[i].id) {
          newState[i].renderedUrl = action.renderedUrl;
          return newState;
        }
      }
      return newState;
    case 'REMOVE_MESSAGE':
      // Find the matching id to remove
      for (let i = 0, len = newState.length; i < len; i++) {
        if (action.id === newState[i].id) {
          newState.splice(i, 1);
          return newState;
        }
      }
      return newState;
    case 'CLEAR_MESSAGES':
      return defaultMessagesState;
    default:
      return state;
  }
};

export default messagesReducer;
